import { RestSlice } from './rest.slice';
import { Jurisdiction } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const settingJurisdictionsSlice = new RestSlice<Jurisdiction>(
	localizationService.getLocalizedString('screen.labels.jurisdictions'),
	Resource.Jurisdictions
);
export const settingJurisdictionsReducer = settingJurisdictionsSlice.rests.reducer;
